import { Panel } from "@/components/admin/ui";
import { timezoneOptionsWithDefault } from "@/lib/timezones";

const inputClass = "mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm font-semibold dark:border-white/15 dark:bg-white/5 dark:text-white";
const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500";

const DATE_FORMATS = [
  { value: "MM/DD/YYYY", label: "MM/DD/YYYY (e.g. 08/29/2026)" },
  { value: "DD/MM/YYYY", label: "DD/MM/YYYY (e.g. 29/08/2026)" },
  { value: "YYYY-MM-DD", label: "YYYY-MM-DD (e.g. 2026-08-29)" },
];
const TIME_FORMATS = [
  { value: "12h", label: "12-hour (e.g. 2:30 PM)" },
  { value: "24h", label: "24-hour (e.g. 14:30)" },
];
const CURRENCIES = [
  { value: "USD", label: "USD - US Dollar" },
  { value: "CAD", label: "CAD - Canadian Dollar" },
  { value: "GBP", label: "GBP - British Pound" },
  { value: "EUR", label: "EUR - Euro" },
  { value: "AUD", label: "AUD - Australian Dollar" },
];

// Org-level regional preferences other Nova Opsis surfaces can consume as they adopt them.
export const RegionalSettingsSection = ({ form, onChange }) => (
  <Panel title="Regional Settings" subtitle="Organization-wide formatting preferences." testId="org-settings-regional">
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <label className={labelClass}>Timezone</label>
        <select value={form.timezone || ""} onChange={(e) => onChange({ timezone: e.target.value })} data-testid="org-settings-timezone-select" className={inputClass}>
          <option value="">Select…</option>
          {timezoneOptionsWithDefault(form.timezone).map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>
      <div>
        <label className={labelClass}>Date Format</label>
        <select value={form.date_format || ""} onChange={(e) => onChange({ date_format: e.target.value })} data-testid="org-settings-date-format-select" className={inputClass}>
          <option value="">Select…</option>
          {DATE_FORMATS.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
        </select>
      </div>
      <div>
        <label className={labelClass}>Time Format</label>
        <select value={form.time_format || ""} onChange={(e) => onChange({ time_format: e.target.value })} data-testid="org-settings-time-format-select" className={inputClass}>
          <option value="">Select…</option>
          {TIME_FORMATS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>
      <div>
        <label className={labelClass}>Currency</label>
        <select value={form.currency || ""} onChange={(e) => onChange({ currency: e.target.value })} data-testid="org-settings-currency-select" className={inputClass}>
          <option value="">Select…</option>
          {CURRENCIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      </div>
    </div>
  </Panel>
);
